import React, { Component } from "react";
import { connect } from 'react-redux';
import * as proActions from "../actions/profiles-actions";
import * as wActs from "../actions/website-actions";
import * as sActs from "../actions/server-actions";
import ProfileItem from "./profileitem";
import * as pConsts from "../consts/profiles-consts";
import Pager from "../components/pager";
import {FormattedMessage} from "react-intl"
import * as wConsts from '../consts/website-consts'
import {ACTION_DISABLE_FORCEXL} from "../consts/website-consts";
import EPomBanner from "./epombanner";
import SwBanner from "./swbanner";

class ProfilesList extends Component {

  constructor(props) {
    super(props);
    this.changePage.bind(this);
    this.currentPage = "";
    this.currentSearch = "";
    this.forceXL = false;
    this.state = {
      listView: "list",
      showTiles: true,
    };

  }

  //let domain = "." + getSubdomain(window.location.hostname);
  //dispatch({ type: wConst.ACTION_FETCH_LOGIN_FULFILLED, payload: "" });
  //localStorage.setItem("siteways-bearer", JSON.stringify(data)); //Setup Bearer For Context Call :)
  //setCookie("auth", data.access_token, { path: "/", maxAge: 31557600, domain: domain });

  getView() {
    try {
      let cVal = wActs.getCookie("view")
      if(!wActs.isNullOrEmpty(cVal)) {
        return cVal;
      } else {
        cVal = sActs.getServerCookie(this.props.WebPage.ServerParams.Cookies,"view");
        if(!wActs.isNullOrEmpty(cVal)) {
          return cVal;
        }
      }
    } catch(ex) {
    }
    return wActs.isNullOrEmpty(this.props.WebPage.Settings.ListView) ? "list" : this.getClass(this.props.WebPage.Settings.ListView);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(typeof window !== "undefined" && window.innerWidth<=767 && this.state.listView !== "list" && this.props.WebPage.ForceXL === "XL") {
      //console.log("Pushing Back");
      this.setState({listView: "list"});
    }
  }

  toggleFilter(e) {
    if(this.props.WebPage.ShowingFilter) {
      this.props.dispatch({type: wConsts.ACTION_HIDE_FILTER});
    } else {
      this.props.dispatch({type: wConsts.ACTION_SHOW_FILTER});
    }
  }

  componentWillMount() {
    if (typeof window === "undefined") { this.props.dispatch(proActions.changeProfiles()); }
    if(this.props.WebPage.Settings.MobileListView === "XL" && this.props.WebPage.ForceXL === "") {
      this.props.dispatch({type: wConsts.ACTION_ENABLE_FORCEXL, payload: "XL"});
    }
    this.setState({listView: this.getView()});
  }

  getClass(key) {
    switch (key.toUpperCase()) {
      case "XL": {
        return "dual";
      }
      case "THUMBS": {
        return "tiles";
      }
      default: {
        return "list";
      }
    }
  }

  componentDidMount() {
    //console.log("List Here");
    window.onresize = () => {
      if(this.props.WebPage.ForceXL === "XL") {
        if(window.innerWidth<767) {
          this.setState({listView: "list"});
        } else {
          this.setState({listView: this.getView()});
        }
      }
    };
  }


  handleClickView(lst) {
    if(window.innerWidth<=767) {
      this.props.dispatch({type: wConsts.ACTION_DISABLE_FORCEXL, payload: "CHG"});
    }
    let domain = "." + wActs.getSubdomain(window.location.hostname);
    wActs.setCookie("view", lst, { path: "/", maxAge: 259200, domain: domain });
    this.setState({ listView: lst });
  }

  getProfiles(page) {
    this.props.dispatch(proActions.getProfiles(page,pConsts.FILTER_PAGESIZE));
  }
  changePage(pge) {
    this.getProfiles(pge);
  }

  render() {
    //throw new Error("Some Fucking Error");
    let self = this;
    let rel = false;

    let proComp = function() { return <p style={{width: "100%", display: "flex", alignContent: "center", justifyContent: "center"}}>
      <img src={`/imgs/${self.props.WebPage.Settings.ColorTheme.toLowerCase()}/loader.gif?v=12`} width={"100px"} height={"100px"} alt={"Loading"}/>
    </p>; }


    if((this.props.State === pConsts.STATE_LOADED && this.props.WebPage.PageLoaded)) { // || (this.props.Page >= 1 && this.props.WebPage.PageLoaded)) {
      //Did Send Related
      if (!wActs.isNullOrUndefined(this.props.ProfilesData.Context) && !wActs.isNullOrUndefined(this.props.ProfilesData.Context.Related) && this.props.ProfilesData.Context.Related === true) {
        rel = true;
      }

      if(this.props.ProfilesData.Context.TotalCount === 0) {
        {/*This is the no results section...*/}
        proComp = () => {
          return (
            <div className="row" style={{margin: "15px"}}>
              <div className="col_50" id={"noresultsimg"}>
                <img src={"/imgs/no-results-img.jpg"} width={"200"} height={"200"} alt={""}/>
              </div>
              <div className="col_50" id={"noresults"}>
                <h4><FormattedMessage id={"page.noresultsfound"}>{(...content) => content}</FormattedMessage></h4>
              </div>
              <div className="col_100" style={{height: '500px'}}>
                &nbsp;
              </div>
            </div>
          );
        }
      } else {
        proComp = function () {
          let pros;
          let out = 0;
          let seeText = self.props.WebPage.Settings.ShowListViews.filter((t) => {return t.toUpperCase() === "LIST"}).length>0;

          pros = self.props.ProfilesData.Result.map((pro)=>{
            out++;
            //For Now Have To Remake Image For Proper Sizes, We Will Use CDN In A Few Dayz
            //The Originals Are Wide/Tall Etc.. Need To Make Proper Sizes On Proxy Side CDN
            //I know They Are Blurry :)
            let img = "/imgs/spacer.gif";
            if(pro.Image) {
              img = pro.Image.Url;
            }

            //Check The Blocks Dude :)
            if(typeof pro.Blocks !=="undefined" && pro.Blocks.length >= 1) {
              let cc = self.props.WebPage.Request.CountryCode; //'RU'
              let fb = false;
              pro.Blocks.forEach((v) => {
                if(v === cc) {
                  //console.log("Blocks: " + v + " == " + cc);
                  fb=true; //No Way Fucker
                } else {
                  //console.log("Blocks: " + v + " != " + cc);
                }
              });
              if(fb) { return null; } //Do Not Write The Model To List :P
            }
            if(out <= pConsts.FILTER_PAGESIZE) {
              return (
                  <ProfileItem key={pro.Id + "-" + self.props.Page} showtext={seeText} Profile={pro} Image={img}/>
                );
            }
            return null;
          });
          return (
            <div>
              {rel &&
                <div className="row" style={{margin: "15px"}}>
                  <div className="col_100">
                    <h6 style={{margin: "15px"}}><FormattedMessage id={"page.noresultsfound"}>{(...content) => content}</FormattedMessage></h6>
                  </div>
                  <div className="col_100">
                    <h4><FormattedMessage id={"page.mostrelevantresultsforyourselection"}>{(...content) => content}</FormattedMessage></h4>
                  </div>
                </div>
              }
              {pros}

              {!rel &&
              <Pager ShowPages={5} Page={self.props.Page} TotalPages={self.props.TotalPages} />
              }
            </div>
          );
        }
      }
      //setTimeout(() => {
      //  window.prerenderReady = true;
      //},1000)

    } else {
      //console.log(`(${this.props.State} === ${pConsts.STATE_LOADED} && ${this.props.WebPage.PageLoaded})`);

    }

    const listActive = this.state.listView === "list" ? " active" : "";
    const tilesActive = this.state.listView === "tiles" ? " active" : "";
    const dualActive = this.state.listView === "dual" ? " active" : "";

    const showList = this.props.WebPage.Settings.ShowListViews.filter((t) => {return t.toUpperCase() === "LIST"}).length>0;
    const showTiles = this.props.WebPage.Settings.ShowListViews.filter((t) => {return t.toUpperCase() === "XS" || t.toUpperCase() === "THUMBS"}).length>0;
    const showDual = this.props.WebPage.Settings.ShowListViews.filter((t) => {return t.toUpperCase() === "XL"}).length>0;


    return (
      <React.Fragment>
        <div className="model-list row thumb_view" style={{marginTop: "20px"}}>
          {proComp()}
        </div>
      </React.Fragment>
    );
  }

}

const mapStateToProps = (state) => {

  return {
    TotalPages: state.ProfilesList.TotalPages,
    Page: state.ProfilesList.Page,
    ProfilesData: state.ProfilesList.ProfilesData,
    State: state.ProfilesList.State,
    WebPage: state.Website,
    ChangeProfiles: state.ProfilesList.ChangeProfiles
  };
}


export default connect(mapStateToProps)(ProfilesList);
